import DataTile from "./DataTile";
import React from "react";
import RiskRibbon from "../../risk/RiskRibbon";
import BBIconArrowsInOut from "../../../assets/bbCustomIcons/BBIconArrowsInOut";
import {useSelector} from "react-redux";
import {fetchTargets} from "../../../actions";
import {bbIsServiceHighRisk, bbTranslateRiskToColor} from "../../../util/bbHelpers";

const Tile = (props) => {

    const {customerId} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customerInView} = useSelector(({customer}) => customer);

    const customerIdToUse = customerId ? customerId : customerInView;

    const colorFunction = (stateData) => {
        const num = valueFunction(stateData);
        return bbTranslateRiskToColor(translateValueToRisk(num));
    }

    const translateValueToRisk = (value) => {
        if (typeof value !== "number") {
            return null
        } else if (value <= 0) {
            return 0
        } else if (value <= 2) {
            return 1
        } else if (value <= 5) {
            return 2
        } else if (value <= 15) {
            return 3
        } else {
            return 4
        }
    }

    const riskRibbon = (stateData) => {
        const num = translateValueToRisk(valueFunction(stateData));
        return num
            ? <RiskRibbon ratingBy5={num} />
            : null;
    }

    const valueFunction = (stateData) => stateData ? stateData[customerIdToUse] ? stateData[customerIdToUse].active_services_list.filter(service => bbIsServiceHighRisk(service)).length : null : null;


    return (
        <DataTile
            color = {colorFunction()}
            colorBgFunction={colorFunction}
            subTitle="High-Risk Services"
            tipText={`Services that have historically demonstrated especially high impact when exploited.  Some attackers specifically look for these services above all others.  Includes RDP, SSH, netBios, SMB, telnet, FTP, and others.`}
            icon={<BBIconArrowsInOut style={{fontSize: "70px"}}/>}
            // icon={<BBIconConstructionCone style={{fontSize: "70px"}}/>}
            stateName="customer"
            stateElement="metaTargets"
            // useDeepDataStore
            // dontFetch
            // forceLoadingState = {true}
            // deepDataStore = {(dataStore) => dataStore? dataStore[customerIdToUse] ? dataStore[customerIdToUse] : null : null}
            stateLoaderName="loadingTargets"
            stateLoaderError="loadingTargetsError"
            stateFetchAction={fetchTargets(
                {
                    customerId: customerIdToUse
                }
            )}
            preventDataFetchConditionFunction={(dataStore) => !customerIdToUse}
            valueFunction={valueFunction}
            ribbonFunction={riskRibbon}
            requiresModule={"monitor"}
        />
    )

}

export default Tile;